import { Injectable } from '@angular/core';
import {ITechnicalApplicationEditModel} from '../api/i-technical-application-edit-model';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  validate(item: ITechnicalApplicationEditModel): boolean  {
    if (item.name === null || item.name.trim() === '' || item.name.length > 200) {
      alert('Name length should be between 1 and 200 characters');
      return false;
    }

    if (item.minSize < 1) {
      alert('Min value should be greater or equal to 1');
      return false;
    }

    if (item.minSize >= item.maxSize) {
      alert('Max value should be greater than Min value');
      return false;
    }

    return true;
  }
}
